import { useEffect, useRef } from "react";
import { prefersReducedMotion } from "./reducedMotion";

// Pure numbers only ("35.000+", "€ 1.800+", "4.9"); words like "20 dagen" stay static.
const PATTERN = /^(€\s?)?(\d{1,3}(?:[.,]\d{3})+|\d+(?:[.,]\d+)?)(\+?)$/;
const DURATION = 1200;

function formatter(num) {
  const thousands = /^\d{1,3}([.,]\d{3})+$/.test(num);
  if (thousands) {
    const sep = num.match(/[.,]/)[0];
    return { target: Number(num.replace(/[.,]/g, "")), fmt: (v) => Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep) };
  }
  const m = num.match(/[.,]/);
  const decimals = m ? num.split(m[0])[1].length : 0;
  return { target: Number(num.replace(",", ".")), fmt: (v) => v.toFixed(decimals).replace(".", m ? m[0] : ".") };
}

export const CountUp = ({ text, className, testid }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    const m = String(text).match(PATTERN);
    if (!el || !m || prefersReducedMotion() || !("IntersectionObserver" in window)) return undefined;
    const [, pre = "", num, suf] = m;
    const { target, fmt } = formatter(num);
    let raf;
    el.textContent = `${pre}${fmt(0)}${suf}`;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const t0 = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - t0) / DURATION);
        const eased = 1 - (1 - p) ** 3;
        el.textContent = p < 1 ? `${pre}${fmt(target * eased)}${suf}` : text;
        if (p < 1) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }, { threshold: 0.4 });
    io.observe(el);
    return () => {
      io.disconnect();
      cancelAnimationFrame(raf);
      el.textContent = text;
    };
  }, [text]);
  return <span ref={ref} data-testid={testid} className={`tabular-nums ${className || ""}`}>{text}</span>;
};
